import * as React from 'react';
import { FC } from 'react';
import { Form } from 'reactstrap';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { MultipleStockItemsField } from '../../../components/Forms/fields';
import { Row } from '../../../components/Forms/table/Row';
import { Col } from '../../../components/Forms/table/Column';
import { ServiceSettings } from '../../../models/api-models';

interface ServiceConfigurationStockTabProps {
    id: string;
    data: ServiceSettings;
    setData: React.Dispatch<React.SetStateAction<ServiceSettings>>;
}

const ServiceConfigurationStockTab: FC<ServiceConfigurationStockTabProps> = ({
    id,
    data,
    setData,
}) => {
    const t = useTranslations();

    return (
        <Form style={{ display: 'flex', marginTop: 'var(--spacer-S)', flexDirection: 'column', gap: 'var(--spacer-M)' }}>
            <Row>
                <Col md={12}>
                    <MultipleStockItemsField
                        id={`${id}-stock-items`}
                        label={t(TK.stock)}
                        values={data.stockItems || []}
                        onChange={stockItems => setData(d => ({ ...d, stockItems }))}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default ServiceConfigurationStockTab;
